<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                            <template v-else>
                                Siswa
                            </template>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/view', params: {id: student.userID} }">
                                {{ student.user.name }}
                            </router-link>
                            <template v-else>
                                {{ student.user.name }}
                            </template>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'student/score', params: {id: student.userID} }">
                                Laporan Nilai Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ tryout.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-sm-4 col-12">
                <div class="row mb-2">
                    <div class="col-5">
                        <label class="font-weight-bold form-divider mb-0">
                            Nama Lengkap
                        </label>
                    </div>
                    <div class="col-7">
                        <template>{{ student.user.name }}</template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5">
                        <label class="font-weight-bold form-divider mb-0">
                            No. Peserta
                        </label>
                    </div>
                    <div class="col-7">
                        {{ student.identity }}
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="row mb-2">
                    <div class="col-5">
                        <label class="font-weight-bold form-divider mb-0">
                            Program Kelas
                        </label>
                    </div>
                    <div class="col-7">
                        <template v-if="Object.keys(guessBranchProgram).length">{{ guessBranchProgram.grade.name }} - {{ guessBranchProgram.programType.name }}</template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5">
                        <label class="font-weight-bold form-divider mb-0">
                            Kelas
                        </label>
                    </div>
                    <div class="col-7">
                        <template v-if="student.studentVerified && student.studentVerified.branchClass">{{ student.studentVerified.branchClass.name }}</template>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="row mb-2">
                    <div class="col-5">
                        <label class="font-weight-bold form-divider mb-0">
                            Mata Pelajaran
                        </label>
                    </div>
		<template v-if="tryout.isSimak != 1">
                    <div class="col-7">
                        <select v-model="form.tryoutSubjectID" class="form-control form-control-sm">
                            <option v-for="tryoutSubject in tryoutSubjects" v-bind:value="tryoutSubject.id" v-bind:key="tryoutSubject.id">{{ tryoutSubject.subject.name }}</option>
                        </select>
                    </div>
		</template>
		<template v-if="tryout.isSimak == 1">
                    <div class="col-7">
                        <select v-model="form.tryoutSubjectID" class="form-control form-control-sm">
                            <option v-for="tryoutSubject in tryoutSubjects" v-bind:value="tryoutSubject.id" v-bind:key="tryoutSubject.id">{{ tryoutSubject.code }}</option>
                        </select>
                    </div>
		</template>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-9 col-sm-12">
                <div class="card shadow-sm mb-4 border-0" v-for="(question, index) in questions" v-bind:key="question.id">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Soal No. {{ question.order }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card-title font-weight-bold mb-3">
                            <div class="row">
                                <template v-if="!question.isEssay">
                                    <div class="col-sm-auto col-12">
                                        Jawaban Benar: {{ question.answer }}
                                    </div>
                                    <div class="col-sm-auto px-0 d-none d-sm-block">
                                        | 
                                    </div>
                                    <div class="col-sm-auto col-12">
                                        Jawaban Siswa: {{ question.studentAnswer }}
                                        <span class="text-uppercase">
                                            <template v-if="question.studentAnswer">
                                                <span v-if="question.answer === question.studentAnswer" class="text-success">(Benar)</span>
                                                <span v-else class="text-danger">(Salah)</span>
                                            </template>
                                            <template v-else>
                                                (Kosong)
                                            </template>
                                        </span>
                                    </div>
                                </template>
                                <div class="col-sm-auto col-12 ml-md-auto">
                                    Persentase Siswa Benar: 
                                    <percentage v-bind:value="+question.correctPercentage"></percentage>
                                </div>
                            </div>
                        </div>
                        <template v-if="question.content || question.choices.length">
                            <div class="row mb-3">
                                <div v-bind:class="['font-weight-bold', question.isEssay ? 'col-sm-6' : 'col-sm-7']">
                                        Deskripsi Soal
                                </div>
                                <div v-bind:class="['font-weight-bold d-none d-sm-block', question.isEssay ? 'col-sm-6' : 'col-sm-5']">
                                    {{ question.isEssay ? 'Jawaban Benar' : 'Opsi Jawaban'}}
                                </div>
                            </div>
                            <div class="row justify-content-end mb-3">
                                <div v-bind:class="['col-12 question-content-wrap', question.isEssay ? 'col-sm-6' : 'col-sm-7']" v-html="question.content"></div>
                                <div v-bind:class="['col-12', question.isEssay ? 'col-sm-6' : 'col-sm-5']">
                                    <template v-if="!question.isEssay">
                                        <div class="row" v-for="choice in question.choices" v-bind:key="choice.order">
                                            <div class="col-auto pr-1">
                                                {{ choice.order }}.
                                            </div>
                                            <div class="col pl-1">
                                                <span v-html="choice.content"></span>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-else v-html="fixRadioAttributes(question.answerString || question.answer, question.id, 'question')"></div>
                                </div>
                            </div>
                        </template>
                        <template v-if="question.isEssay">
                            <div class="row mb-3">
                                <div class="col-12 font-weight-bold mb-3">
                                    Jawaban Siswa
                                    <template v-if="question.studentAnswerString || question.studentAnswer">
                                        <span v-if="checkIsCorrect(question.answerString || question.answer, question.studentAnswerString || question.studentAnswer)" class="text-success">(Benar)</span>
                                        <span v-else class="text-danger">(Salah)</span>
                                    </template>
                                </div>
                                <div class="col-12">
                                    <div v-if="!!question.studentAnswer || !!question.studentAnswerString" v-html="fixRadioAttributes(question.studentAnswerString || question.studentAnswer, question.id, '', question.answerString || question.answer)"></div>
                                    <p v-else>(Kosong)</p>
                                </div>
                            </div>
                        </template>
                        <template v-if="question.solution">
                            <div class="row justify-content-end mb-3">
                                <div class="col font-weight-bold">
                                    Pembahasan 
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div v-html="question.solution.content"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-sm-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import Percentage from "@/components/item/Percentage";
    import { mapState } from 'vuex';
    /**
     * @param {Object} tryoutSubject
     */
    export default {
        name: "StudentTryoutView",
        components: {
            Paginate,
            Percentage
        },
        watch: {
            'form.tryoutSubjectID'() {
                this.paginate(1);
            }
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    tryoutSubjectID: ''
                },
                student: {user: {}},
                tryout: {},
                tryoutSubjects: [],
                questions: [],
                guessBranchProgram: {},
                pageCount: 0,
                page: 1
            };
        },
        methods: {
            paginate(page) {
                this.axios.get(process.env.API_URL + '/student/tryout-analysis', {params: {studentID: this.student.userID, tryoutID: this.tryout.id, tryoutSubjectID: this.form.tryoutSubjectID, page: page}}).then(response => {
                    this.questions = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;
                });
            },
            roleElligibleView() {
                if (!this.profile) return false;
                return Boolean(this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee && (this.profile.employee.isDirector || this.profile.employee.isManager)));
            },
            fixRadioAttributes(html, questionId, type, keyHtml) {
                let rawHtml = typeof html === 'object' && html !== null ? (html.value || '') : (html || '');
                let rawKeyHtml = typeof keyHtml === 'object' && keyHtml !== null ? (keyHtml.value || '') : (keyHtml || '');

                if (!rawHtml && !rawKeyHtml) return '';

                const isStudentAnswer = (type !== 'question');

                try {
                    const parser = new DOMParser();
                    const docHtml = parser.parseFromString(rawHtml || '', 'text/html');
                    const docKey = rawKeyHtml ? parser.parseFromString(rawKeyHtml, 'text/html') : null;

                    // Check whether it's Table or List
                    const tblKey = docKey ? docKey.querySelector('table') : null;
                    const tblHtml = docHtml.querySelector('table');
                    const isTable = (tblKey && tblKey.querySelector('input[type="radio"]')) || (tblHtml && tblHtml.querySelector('input[type="radio"]'));

                    const ulKey = docKey ? docKey.querySelector('ul') : null;
                    const ulHtml = docHtml.querySelector('ul');
                    const isList = (ulKey && ulKey.querySelector('input[type="checkbox"]')) || (ulHtml && ulHtml.querySelector('input[type="checkbox"]'));

                    // Helper to check if input is checked
                    const isInputChecked = (el) => {
                        if (!el) return false;
                        return !!(
                            el.hasAttribute('checked') ||
                            el.checked === true ||
                            el.defaultChecked === true ||
                            (el.getAttribute('checked') !== null && el.getAttribute('checked') !== 'false') ||
                            (el.outerHTML && /checked/i.test(el.outerHTML))
                        );
                    };

                    // 1. Tipe TABEL
                    if (isTable) {
                        const tableSource = (isStudentAnswer && tblKey) ? tblKey : (tblHtml || tblKey);
                        let headers = tableSource.querySelectorAll('thead th');
                        if (!headers || headers.length === 0) {
                            const firstTr = tableSource.querySelector('tr');
                            if (firstTr) {
                                headers = firstTr.querySelectorAll('th, td');
                            }
                        }
                        let colStmtLabel = 'Pernyataan';
                        let col1Label = 'Benar';
                        let col2Label = 'Salah';
                        if (headers.length === 3) {
                            colStmtLabel = headers[0] ? headers[0].textContent.trim() : 'Pernyataan';
                            col1Label = headers[1] ? headers[1].textContent.trim() : 'Benar';
                            col2Label = headers[2] ? headers[2].textContent.trim() : 'Salah';
                        } else if (headers.length >= 4) {
                            colStmtLabel = headers[1] ? headers[1].textContent.trim() : 'Pernyataan';
                            col1Label = headers[2] ? headers[2].textContent.trim() : 'Benar';
                            col2Label = headers[3] ? headers[3].textContent.trim() : 'Salah';
                        }

                        // Get rows from key (to get the latest revised statements) or tableSource
                        const getTrList = (tableEl) => {
                            if (!tableEl) return [];
                            let list = tableEl.querySelectorAll('tbody tr');
                            if (!list || list.length === 0) list = tableEl.querySelectorAll('tr');
                            return Array.from(list).filter(tr => tr.querySelector('input[type="radio"]'));
                        };
                        const keyRows = tblKey ? getTrList(tblKey) : (tblHtml ? getTrList(tblHtml) : []);
                        const studentRows = tblHtml ? getTrList(tblHtml) : [];

                        let rowsHtml = '';
                        keyRows.forEach((kRow, idx) => {
                            const kCells = kRow.querySelectorAll('td');
                            if (kCells.length < 3) return;

                            // Extract revised statement from key row (dynamic sync!)
                            const stmtCell = (kCells.length === 3) ? kCells[0] : kCells[1];
                            const stmtClone = stmtCell.cloneNode(true);
                            stmtClone.querySelectorAll('input').forEach(inp => inp.remove());
                            const scrollWrap = stmtClone.querySelector('.statement-scroll-wrap');
                            let stmtContent = scrollWrap ? scrollWrap.innerHTML.trim() : stmtClone.innerHTML.trim();
                            stmtContent = stmtContent.replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>)+$/gi, '').trim();

                            // Determine checked state
                            let col1Checked = false;
                            let col2Checked = false;

                            if (isStudentAnswer) {
                                // Pull student's selection for this row
                                if (studentRows[idx]) {
                                    const sRadios = Array.from(studentRows[idx].querySelectorAll('input[type="radio"]'));
                                    if (sRadios.length >= 2) {
                                        col1Checked = isInputChecked(sRadios[0]);
                                        col2Checked = isInputChecked(sRadios[1]);
                                    }
                                }
                            } else {
                                // For key answer, pull key's checked state
                                const kRadios = Array.from(kRow.querySelectorAll('input[type="radio"]'));
                                if (kRadios.length >= 2) {
                                    col1Checked = isInputChecked(kRadios[0]);
                                    col2Checked = isInputChecked(kRadios[1]);
                                }
                            }

                            const radioName = `${type || 'student'}_answers_${questionId}_[${idx}]`;

                            rowsHtml += '<tr>';
                            rowsHtml += `<td style="width:50px;min-width:50px;max-width:50px;text-align:center;font-weight:bold;vertical-align:middle;">${idx + 1}</td>`;
                            rowsHtml += `<td class="text-justify table-statement-cell" style="text-align:justify !important;text-justify:inter-word;vertical-align:middle;"><div class="statement-scroll-wrap">${stmtContent}</div></td>`;
                            rowsHtml += `<td style="width:90px;min-width:90px;max-width:90px;text-align:center;vertical-align:middle;"><input type="radio" name="${radioName}" value="col1" ${col1Checked ? 'checked="checked"' : ''} onclick="return false;" style="pointer-events:none;cursor:default;" /></td>`;
                            rowsHtml += `<td style="width:90px;min-width:90px;max-width:90px;text-align:center;vertical-align:middle;"><input type="radio" name="${radioName}" value="col2" ${col2Checked ? 'checked="checked"' : ''} onclick="return false;" style="pointer-events:none;cursor:default;" /></td>`;
                            rowsHtml += '</tr>';
                        });

                        const theadHtml = `<thead><tr><th style="width:50px;min-width:50px;max-width:50px;text-align:center;">No</th><th style="text-align:center;">${colStmtLabel}</th><th style="width:90px;min-width:90px;max-width:90px;text-align:center;">${col1Label}</th><th style="width:90px;min-width:90px;max-width:90px;text-align:center;">${col2Label}</th></tr></thead>`;

                        return `<table border="1" class="table table-bordered mb-0" style="width:100%;max-width:100%;table-layout:fixed;">${theadHtml}<tbody>${rowsHtml}</tbody></table>`;
                    }

                    // 2. Tipe LIST
                    if (isList) {
                        const listSource = (isStudentAnswer && ulKey) ? ulKey : (ulHtml || ulKey);
                        const keyItems = ulKey ? ulKey.querySelectorAll('li') : (ulHtml ? ulHtml.querySelectorAll('li') : []);
                        const studentItems = ulHtml ? ulHtml.querySelectorAll('li') : [];

                        let itemsHtml = '';
                        keyItems.forEach((kLi, idx) => {
                            // Extract revised statement (dynamic sync!)
                            const contentDiv = kLi.querySelector('.list-statement-content');
                            let stmtContent = contentDiv ? contentDiv.innerHTML.trim() : '';
                            if (!stmtContent) {
                                const clone = kLi.cloneNode(true);
                                clone.querySelectorAll('input').forEach(inp => inp.remove());
                                const lbl = clone.querySelector('label');
                                stmtContent = lbl ? lbl.innerHTML.trim() : clone.innerHTML.trim();
                            }
                            stmtContent = stmtContent.replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>)+$/gi, '').trim();

                            let isChecked = false;
                            if (isStudentAnswer) {
                                if (studentItems[idx]) {
                                    const cb = studentItems[idx].querySelector('input[type="checkbox"]');
                                    isChecked = isInputChecked(cb);
                                }
                            } else {
                                const cb = kLi.querySelector('input[type="checkbox"]');
                                isChecked = isInputChecked(cb);
                            }

                            const cbName = `${type || 'student'}_lst_checkbox_${questionId}_${idx}`;
                            itemsHtml += `<li style="list-style:none;margin-bottom:10px;text-align:justify !important;display:flex;align-items:flex-start;width:100%;"><input type="checkbox" name="${cbName}" value="${idx}" ${isChecked ? 'checked="checked"' : ''} onclick="return false;" style="margin-right:10px;margin-top:4px;flex-shrink:0;pointer-events:none;cursor:default;" /><div class="list-statement-content" style="flex-grow:1;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;text-align:justify !important;text-justify:inter-word;pointer-events:auto;">${stmtContent}</div></li>`;
                        });

                        return `<ul class="list-unstyled mb-0" style="list-style:none;padding-left:0;text-align:justify !important;">${itemsHtml}</ul>`;
                    }

                } catch (e) {
                    console.error('Error in fixRadioAttributes:', e);
                }

                // Fallback for regular essay or unexpected structure
                let withUniqueNames = rawHtml.replace(/name=(['"])answers\[/g, `name=$1${type}_answers_${questionId}_[`);
                withUniqueNames = withUniqueNames.replace(/name=(['"])(?:table|tbl)-radio-(\d+)/g, `name=$1${type}_tbl_radio_${questionId}_$2`);
                withUniqueNames = withUniqueNames.replace(/name=(['"])(?:list|lst)-(?:checkbox|chk)-(\d+)/g, `name=$1${type}_lst_checkbox_${questionId}_$2`);
                const withFixedChecks = withUniqueNames.replace(/checked=(['"])checked\1/g, 'checked');
                return withFixedChecks;
            },
            sanitizeAnswerString(html) {
                if (!html) return '';

                const div = document.createElement('div');
                div.innerHTML = html;

                div.querySelectorAll('[data-mce-selected]').forEach(el => {
                    el.removeAttribute('data-mce-selected');
                });

                div.querySelectorAll('input[checked]').forEach(input => {
                    input.removeAttribute('checked');
                    input.setAttribute('checked', 'checked');
                });

                const table = div.querySelector('table');
                if (table) {
                    let next = table.nextSibling;
                    while (next) {
                        let toRemove = next;
                        next = next.nextSibling;
                        toRemove.remove();
                    }
                }
                return div.innerHTML;
            },
            checkIsCorrect(key, student) {
                let keyHTML = typeof key === 'object' && key !== null ? (key.value || '') : (key || '');
                let studentHTML = typeof student === 'object' && student !== null ? (student.value || '') : (student || '');

                if (!keyHTML || !studentHTML) return false;

                const createDoc = (html) => {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    return div;
                };

                const isInputChecked = (el) => {
                    if (!el) return false;
                    return !!(
                        el.hasAttribute('checked') || 
                        el.checked === true || 
                        el.defaultChecked === true || 
                        (el.getAttribute('checked') !== null && el.getAttribute('checked') !== 'false') ||
                        (el.outerHTML && /checked/i.test(el.outerHTML))
                    );
                };

                const docKey = createDoc(keyHTML);
                const docStudent = createDoc(studentHTML);

                // 1. Tipe TABEL (mengandung table dan radio)
                const tblKey = docKey.querySelector('table');
                const hasRadio = docKey.querySelector('input[type="radio"]');
                if (tblKey && hasRadio) {
                    const getRadioRows = (container) => {
                        const trs = container.querySelectorAll('tr');
                        const res = [];
                        trs.forEach(tr => {
                            if (tr.querySelector('input[type="radio"]')) {
                                res.push(tr);
                            }
                        });
                        return res;
                    };

                    const rowsKey = getRadioRows(docKey);
                    const rowsStudent = getRadioRows(docStudent);

                    if (!rowsKey.length || rowsKey.length !== rowsStudent.length) {
                        return false;
                    }

                    for (let i = 0; i < rowsKey.length; i++) {
                        const rKey = Array.from(rowsKey[i].querySelectorAll('input[type="radio"]'));
                        const rStudent = Array.from(rowsStudent[i].querySelectorAll('input[type="radio"]'));

                        if (!rKey.length || rKey.length !== rStudent.length) return false;

                        let idxKey = -1;
                        let idxStudent = -1;
                        let valKey = null;
                        let valStudent = null;

                        rKey.forEach((inp, idx) => {
                            if (isInputChecked(inp)) {
                                idxKey = idx;
                                valKey = inp.getAttribute('value');
                            }
                        });

                        rStudent.forEach((inp, idx) => {
                            if (isInputChecked(inp)) {
                                idxStudent = idx;
                                valStudent = inp.getAttribute('value');
                            }
                        });

                        // Murid benar jika radio yang dicentang di kolom yang sama dengan kunci (atau value sama)
                        const isMatch = (idxKey !== -1 && idxKey === idxStudent) || 
                                        (valKey !== null && valStudent !== null && valKey === valStudent);

                        if (!isMatch) {
                            return false;
                        }
                    }

                    return true;
                }

                // 2. Tipe LIST (Checkbox)
                const cbsKey = Array.from(docKey.querySelectorAll('input[type="checkbox"]'));
                const cbsStudent = Array.from(docStudent.querySelectorAll('input[type="checkbox"]'));

                if (cbsKey.length > 0) {
                    if (cbsStudent.length !== cbsKey.length) return false;

                    for (let i = 0; i < cbsKey.length; i++) {
                        if (isInputChecked(cbsKey[i]) !== isInputChecked(cbsStudent[i])) {
                            return false;
                        }
                    }

                    return true;
                }

                // 3. Fallback Essay teks biasa
                const cleanStr = (str) => {
                    return (str || '')
                        .replace(/<[^>]*>/g, '')
                        .replace(/&nbsp;/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim()
                        .toLowerCase();
                };

                if (cleanStr(keyHTML) === cleanStr(studentHTML)) {
                    return true;
                }

                return this.sanitizeAnswerString(keyHTML) === this.sanitizeAnswerString(studentHTML);
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.tryoutID),
                this.axios.get(process.env.API_URL + '/student/' + this.$route.params.id)
            ]).then(this.axios.spread(function (responseTryout, responseStudent) {
                this.tryout = responseTryout.data.data;
                if (this.tryout.tryoutGroups.length) {
                    for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                        this.tryoutSubjects.push(...this.tryout.tryoutGroups[i].tryoutSubjects);
                    }
                } else {
                    this.tryoutSubjects = this.tryout.tryoutSubjects;
                }
                if (this.tryoutSubjects[0]) {
                    this.form.tryoutSubjectID = this.tryoutSubjects[0].id;
                }

                this.student = responseStudent.data.data;
                if (this.student.studentVerified) {
                    if (this.student.studentVerified.pattern) {
                        this.guessBranchProgram = this.student.studentVerified.pattern.branchProgram || {};
                    }
                    if (!Object.keys(this.guessBranchProgram).length && this.student.studentVerified.intensiveSchedule) {
                        this.guessBranchProgram = this.student.studentVerified.intensiveSchedule.branchProgram;
                    }
                }

                document.title = 'Tryout Offline ' + this.student.user.name + ' - ' + this.tryout.name + ' - ' + process.env.APP_NAME;
            }.bind(this)));
        }
    };
</script>

<style scoped>
    .table td.text-justify,
    .table td.text-justify p,
    .table td:nth-child(2),
    .table td:nth-child(2) p,
    /deep/ .table td.text-justify,
    /deep/ .table td.text-justify p,
    /deep/ .table td:nth-child(2),
    /deep/ .table td:nth-child(2) p,
    /deep/ .list-statement-content,
    /deep/ .list-statement-content p,
    /deep/ ul li,
    /deep/ ul li div,
    /deep/ ul li p {
        text-align: justify !important;
        text-justify: inter-word !important;
        margin-bottom: 0 !important;
    }

    /deep/ tbody tr {
        transition: background-color 0.15s ease-in-out;
    }
    /deep/ tbody tr:hover td {
        background-color: #edf4fc !important;
    }

    /deep/ img {
        -webkit-user-drag: none !important;
        user-drag: none !important;
        user-select: none !important;
        -webkit-user-select: none !important;
    }

    /deep/ table {
        table-layout: fixed !important;
        width: 100% !important;
        max-width: 100% !important;
        border-collapse: collapse !important;
        margin-bottom: 0 !important;
    }

    /deep/ table.table-bordered th,
    /deep/ table.table-bordered td {
        border: 1px solid #dee2e6 !important;
    }

    /* Kolom 1 (No) */
    /deep/ th:nth-child(1),
    /deep/ td:nth-child(1) {
        width: 45px !important;
        min-width: 45px !important;
        max-width: 45px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }
    /deep/ thead th:nth-child(1) {
        background-color: #f8f9fa !important;
    }

    /* Kolom 2 (Statement) Header tetap di tengah dan tidak bergeser */
    /deep/ thead th:nth-child(2) {
        text-align: center !important;
        background-color: #f8f9fa !important;
        vertical-align: middle !important;
        width: auto !important;
    }

    /* Kolom 2 (Statement) Baris data di bawah header */
    /deep/ td.table-statement-cell,
    /deep/ td:nth-child(2) {
        width: auto !important;
        vertical-align: middle !important;
        padding-top: 0.6rem !important;
        padding-bottom: 0.6rem !important;
        overflow: hidden !important;
    }

    /deep/ .statement-scroll-wrap {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        white-space: normal;
        margin: 0 !important;
        padding: 0 !important;
    }

    /deep/ .statement-scroll-wrap p,
    /deep/ td.table-statement-cell p {
        margin: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding: 0 !important;
        line-height: 1.5 !important;
    }
    /deep/ .statement-scroll-wrap p:not(:last-child),
    /deep/ td.table-statement-cell p:not(:last-child) {
        margin-bottom: 0.35rem !important;
    }
    /deep/ .statement-scroll-wrap p:empty,
    /deep/ td.table-statement-cell p:empty {
        display: none !important;
    }

    /* Kolom 3 (Pilihan 1 / Benar) */
    /deep/ th:nth-child(3),
    /deep/ td:nth-child(3) {
        width: 75px !important;
        min-width: 75px !important;
        max-width: 75px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }
    /deep/ thead th:nth-child(3) {
        background-color: #f8f9fa !important;
    }

    /* Kolom 4 (Pilihan 2 / Salah) */
    /deep/ th:nth-child(4),
    /deep/ td:nth-child(4) {
        width: 75px !important;
        min-width: 75px !important;
        max-width: 75px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
    }
    /deep/ thead th:nth-child(4) {
        background-color: #f8f9fa !important;
    }

    /* Radio button & Checkbox: matikan interaksi (tidak bisa diubah), cursor default */
    /deep/ input[type="radio"],
    /deep/ input[type="checkbox"] {
        pointer-events: none !important;
        cursor: default !important;
    }
    /deep/ td[style*="cursor: pointer"],
    /deep/ td {
        cursor: default !important;
    }

    /deep/ tbody tr {
        transition: background-color 0.15s ease-in-out;
    }
    /deep/ tbody tr:hover td {
        background-color: #edf4fc !important;
    }

    /* Scrollbar horizontal rapi: track transparan agar tidak muncul kotak/garis abu-abu di bawah teks biasa */
    /deep/ .statement-scroll-wrap::-webkit-scrollbar,
    /deep/ .list-statement-content::-webkit-scrollbar {
        height: 6px;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-track,
    /deep/ .list-statement-content::-webkit-scrollbar-track {
        background: transparent !important;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb,
    /deep/ .list-statement-content::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb:hover,
    /deep/ .list-statement-content::-webkit-scrollbar-thumb:hover {
        background: #888;
    }
    /deep/ td img,
    /deep/ .statement-scroll-wrap img,
    /deep/ .list-statement-content img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
        mix-blend-mode: multiply !important;
        background-color: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    /deep/ ul li {
        transition: background-color 0.15s ease-in-out;
        border-radius: 4px;
        padding: 4px 8px;
        max-width: 100% !important;
        overflow: hidden !important;
    }
    /deep/ ul li:hover {
        background-color: #edf4fc !important;
    }

    /deep/ .list-statement-content {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        min-width: 0 !important;
        max-width: 100% !important;
        pointer-events: auto !important;
    }

    /* Deskripsi Soal: jika gambar sangat panjang, pertahankan ukuran aslinya & bisa digeser */
    /deep/ .question-content-wrap {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        max-width: 100% !important;
    }

    /deep/ .question-content-wrap img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
    }

    /* Scrollbar horizontal rapi untuk Deskripsi Soal: track transparan */
    /deep/ .question-content-wrap::-webkit-scrollbar {
        height: 6px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-track {
        background: transparent !important;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb:hover {
        background: #888;
    }
</style>


// WEBPACK FOOTER //
// src/components/student/tryout/View.vue